<template>
  <div class="myevents container-fluid">
    <div class="container-fluid">
      <div class="row" id="dashboardCardDiv">
        <div class="col-md-12">
          <div class="card card-transparent-background">
            <div class="card-header card-header-icon row">
              <div class="col-12 pl-0">
                <h4 class="card-title card-title-doom-yoga">Create An Event</h4>
              </div>
            </div>
          </div>
          <EventsList
            client_name="DY"
            :filter_buttons="filter_buttons"
            :events="events"
            :currency="'€'"
            images_folder="doom-yoga"
            sub_title="My Classes"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import $ from "jquery";
import EventsList from "@/components/events/List.vue";

export default {
  name: "MyEevents",
  components: { EventsList },
  data() {
    return {
      filter_buttons: [
        { name: "Class", value: "class" },
        { name: "Course", value: "course" },
        { name: "Private Class", value: "private_class" },
      ],
      events: [
        // {
        //   id: 1,
        //   name: "DO.OM YOGA ONLINE PRACTICE",
        //   type: "class",
        //   max_participants: 150,
        //   address: "ZOOM ONLINE : Video Conferencing",
        //   pricing: 100,
        //   is_view: true,
        //   cover: { path:
        //     "https://upload.wikimedia.org/wikipedia/commons/thumb/0/0a/Aum_Om_black.svg/1200px-Aum_Om_black.svg.png",},
        //   has_sessions: true,
        // },
        // {
        //   id: 2,
        //   name: "DO.OM YOGA ONLINE PRACTICE",
        //   type: "class",
        //   max_participants: 150,
        //   address: "ZOOM ONLINE : Video Conferencing",
        //   pricing: 100,
        //   is_view: false,
        //   cover: { path: "",},
        //   has_sessions: false,
        // }, {
        //   id: 1,
        //   name: "DO.OM YOGA ONLINE PRACTICE",
        //   type: "class",
        //   max_participants: 150,
        //   address: "ZOOM ONLINE : Video Conferencing",
        //   pricing: 100,
        //   is_view: true,
        //   cover: { path:
        //     "https://upload.wikimedia.org/wikipedia/commons/thumb/0/0a/Aum_Om_black.svg/1200px-Aum_Om_black.svg.png",},
        //   has_sessions: true,
        // },
        // {
        //   id: 2,
        //   name: "DO.OM YOGA ONLINE PRACTICE",
        //   type: "class",
        //   max_participants: 150,
        //   address: "ZOOM ONLINE : Video Conferencing",
        //   pricing: 100,
        //   is_view: false,
        //   cover: { path: "",},
        //   has_sessions: false,
        // },
        // {
        //   id: 3,
        //   name: "DO.OM YOGA ONLINE PRACTICE test",
        //   type: "course",
        //   max_participants: 150,
        //   address: "ZOOM ONLINE : Video Conferencing",
        //   pricing: 100,
        //   is_view: true,
        //   cover: { path:
        //     "https://upload.wikimedia.org/wikipedia/commons/thumb/0/0a/Aum_Om_black.svg/1200px-Aum_Om_black.svg.png",},
        //   has_sessions: null,
        // },
        // {
        //   id: 4,
        //   name: "DO.OM YOGA ONLINE PRACTICE test2 sss",
        //   type: "course",
        //   max_participants: 150,
        //   address: "ZOOM ONLINE : Video Conferencing",
        //   pricing: 100,
        //   is_view: false,
        //   cover: { path:
        //     "https://upload.wikimedia.org/wikipedia/commons/thumb/0/0a/Aum_Om_black.svg/1200px-Aum_Om_black.svg.png",},
        //   has_sessions: null,
        // },
        // {
        //   id: 5,
        //   name: "DO.OM YOGA ONLINE PRACTICE",
        //   type: "private_class",
        //   max_participants: 150,
        //   address: "ZOOM ONLINE : Video Conferencing",
        //   pricing: 100,
        //   is_view: true,
        //   cover: { path: "",},
        //   has_sessions: null,
        // },
      ],
    };
  },
  mounted() {
    this.getEventsList();
  },
  computed: {},
  created() {},
  methods: {
    getEventsList() { 
      // console.log(JSON.parse(window.localStorage.getItem("user")).access_token)
     axios
        .get("event/events", {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            client: "DY",
            Authorization:
              "Bearer " +
              JSON.parse(window.localStorage.getItem("user")).access_token,
          },
        })
        .then((response) => {
          console.log(response);
          this.events = response.data;
        });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/doom_yoga/events/List.vue